import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgNominations({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M13.5 12.25a1 1 0 011 1v.5a1 1 0 01-1 1h-11a1 1 0 01-1-1v-.5a1 1 0 011-1h11zM4.95 6.5v5h-1.7v-5h1.7zm3.9 0v5h-1.7v-5h1.7zm3.9 0v5h-1.7v-5h1.7zM8.36 1.34l5.78 3.15c.64.35.37 1.26-.36 1.26H2.22c-.73 0-1-.91-.36-1.26l5.78-3.15c.22-.12.5-.12.72 0z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgNominations.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgNominations.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgNominations svgRef={ref} {...props} />);
export default ForwardRef;
